import { FC, useEffect, useState } from 'react'
import { StyledSystemThemeProvider, utils } from '@icanbwell/ui-toolkit'
import { useGetClientBrandingQuery } from '@client-hub/store/api/gcs/augmented'
import { useClientConfigurationQuery } from '@client-hub/store/api/crs/react'
import { Loader } from '@icanbwell/ui-toolkit'
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query'
import { useNavigate } from 'react-router-dom'
import HubNotFound from 'components/HubNotFound'
import ROUTES from '@client-hub/shared/constants/routes'

const ThemeProvider: FC = ({ children }) => {
  const navigate = useNavigate()
  const [showNotFoundPage, setShowNotFoundPage] = useState<boolean>(false)
  /**
   * fetches the "frontend_environment" variable and sets it to state.
   */
  const { data: clientConfigurationData, error: clientConfigurationError } = useClientConfigurationQuery()

  /**
   * reads the value of "frontend_environment" and fetches the actual theme.
   */
  const { data, isFetching: isFetchingBrandingQuery, isUninitialized } = useGetClientBrandingQuery()

  /**
   * The "ThemeProvider" never unmounts, so we can maintain the theme locally in this component
   * for faster access.
   */
  const [themeData, setThemeData] = useState<any>(undefined)

  useEffect(() => {
    if (!isFetchingBrandingQuery && !isUninitialized && clientConfigurationData) {
      /**
       * The above checks make sure that the fetched theme was of the intended client and
       * not the default client
       */
      setThemeData(data)
    }
  }, [isFetchingBrandingQuery, isUninitialized])

  useEffect(() => {
    if (clientConfigurationError && (clientConfigurationError as FetchBaseQueryError).status === 404) {
      navigate(ROUTES.NOT_FOUND)
      setShowNotFoundPage(true)
    }
  }, [clientConfigurationError])

  if (showNotFoundPage) {
    return <HubNotFound returnToHomeLink={ROUTES.BASE} />
  }

  if (!themeData)
    return (
      // default "heart" loader
      // TODO: (clarify) if this needs to be replaced by an SSR loader.
      <StyledSystemThemeProvider theme={{} as utils.Theme}>
        <Loader variant="fullpage" />
      </StyledSystemThemeProvider>
    )
  else
    return (
      <StyledSystemThemeProvider
        theme={themeData?.theme as utils.Theme}
        fontUrls={utils.configServiceFontsToUrls(themeData?.branding?.themeUrls?.fonts as Record<string, string>)}
      >
        {children}
      </StyledSystemThemeProvider>
    )
}

export default ThemeProvider
